import styled from '@emotion/styled';

const ResponsiveImage = styled.div(props => ({
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
  maxHeight: `550px`,
  overflow: `hidden`,
  borderBottom: `1px solid ${props.theme.primaryAccent || props.theme.primary}`
}));

const HeaderImage = styled.img`
  display: block;
  position: relative;
  background-size: contain;
  margin: 0px;
  overflow: hidden;
`;

export { ResponsiveImage, HeaderImage };
